const FeatureFlags = {
  install (Vue, options) {
    if (!options) {
      throw new Error('FeatureManager requires options')
    }
    const env = process.env.NODE_ENV
    let cfg = options.production

    // Unify “featureValue” from wesave-conseil-front/app-config.js
    if ((env === 'staging' || env === 'development') && options.staging) {
      for (let prop in options.staging) {
        if (options.staging.hasOwnProperty(prop) && options.production.hasOwnProperty(prop)) {
          cfg[prop] = options.staging[prop]
        } else if (!options.production.hasOwnProperty(prop)) {
          throw new Error('Feature not defined in production. Make sure it exists there before overwriting for staging/development')
        }
      }
    }

    if (env === 'pre-production' && options.preProduction) {
      for (let prop in options.preProduction) {
        if (options.preProduction.hasOwnProperty(prop) && options.production.hasOwnProperty(prop)) {
          cfg[prop] = options.preProduction[prop]
        } else if (!options.production.hasOwnProperty(prop)) {
          throw new Error('Feature not defined in production. Make sure it exists there before overwriting for pre-production')
        }
      }
    }

    Vue.prototype.$featureFlag = (featureName) => {
      if (!cfg.hasOwnProperty(featureName)) {
        throw new Error(`Feature name does not exist - ${feature}`)
      } else {
        return Boolean(cfg[featureName])
      }
    }

    Vue.prototype.$featureValue = (featureName) => {
      if (!cfg.hasOwnProperty(featureName)) {
        throw new Error(`Feature name does not exist - ${feature}`)
      } else {
        return cfg[featureName]
      }
    }
  }
}

export default FeatureFlags
